import { useEffect, useState } from "react";

export function useProgram(studentId, resetForm) {
  const [program, setProgram] = useState("");

  useEffect(() => {
    if (!studentId) return;

    const storedProgram =
      localStorage.getItem(`selectedProgram_${studentId}`) || "";
    setProgram(storedProgram);

    if (resetForm) {
      resetForm((prevValues) => ({
        ...prevValues,
        subject_code: storedProgram, // Ensure form updates
      }));
    }
  }, [studentId]); // Reset form when studentId changes

  useEffect(() => {
    const syncProgram = () => {
      const storedProgram =
        localStorage.getItem(`selectedProgram_${studentId}`) || "";
      setProgram(storedProgram);

      if (resetForm) {
        resetForm((prevValues) => ({
          ...prevValues,
          subject_code: storedProgram, // Ensure UI updates
        }));
      }
    };

    window.addEventListener("storage", syncProgram);
    return () => window.removeEventListener("storage", syncProgram);
  }, [studentId]);

  const handleProgramChange = (selectedProgram) => {
    setProgram(selectedProgram);
    localStorage.setItem(`selectedProgram_${studentId}`, selectedProgram);
    window.dispatchEvent(new Event("storage"));
  };

  return { program, handleProgramChange };
}
